import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  inject,
  OnDestroy,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { ApiService } from '@core/providers/http';
import { CompetenciaService } from '@app/features-modules/bolsa-de-profissionais/services';
import {
  PaisService,
  ProvinciaService,
} from '@app/features-modules/gestao-bolseiros/components/api/services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { CadastrarEmpresaComponent } from '../cadastrar-empresa/cadastrar-empresa.component';
import { TableModule } from 'primeng/table';
import { DatePicker } from 'primeng/datepicker';
import { TagModule } from 'primeng/tag';
import { InputText } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { ListaRepresentantesComponent } from './components/representantes/lista-representantes/lista-representantes.component';
import { ListaProfissionaisComponent } from './components/profissionais/lista-profissionais/lista-profissionais.component';
import { ListaVagasComponent } from './components/vagas/lista-vagas/lista-vagas.component';
import { SubSectorPipe } from '@app/features-modules/bolsa-de-profissionais/pipes/sub-sector.pipe';
import { DrawerModule } from 'primeng/drawer';
import { MaisDetalheEmpresaComponent } from './components/mais-detalhe-empresa/mais-detalhe-empresa.component';
import {
  EmpresaSectorService,
  ProfissionalService,
  PlanoRecrutamentoService,
  ProfissionaisEnumService,
} from '@app/features-modules/bolsa-de-profissionais/services';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models';
import { TableComponent } from '@app/shared/components/table/table.component';
import { TableColumn } from '@app/shared/components/table/table.component';
import { Pagination } from '@app/shared/model';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { DialogModule } from 'primeng/dialog';
import { forkJoin } from 'rxjs';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { PlanoRecrutamentoVagaService } from '@app/features-modules/bolsa-de-profissionais/services/plano-recrutamento-vaga.service';
import { Checkbox } from 'primeng/checkbox';
import { TextareaModule } from 'primeng/textarea';
import { HasAnyRoleDirective } from '@core/directives/has-any-role.directive';
import { PdrhComponent } from './components/pdrh/pdrh.component';
import { Avatar } from 'primeng/avatar';
import { AvatarGroup } from 'primeng/avatargroup';
import { TooltipModule } from 'primeng/tooltip';
import { getInitials } from '@shared/pipes/initials.pipe';
type ButtonSeverity =
  | 'success'
  | 'secondary'
  | 'info'
  | 'warn'
  | 'danger'
  | 'contrast'
  | 'help'
  | 'primary'
  | null
  | undefined;
@Component({
  selector: 'app-detalhe-empresa',
  imports: [
    CommonModule,
    BackButtonComponent,
    ButtonModule,
    TabsModule,
    TableModule,
    ToastModule,
    ConfirmDialog,
    TagModule,
    MenuModule,
    SelectModule,
    DatePicker,
    InputText,
    ListaRepresentantesComponent,
    ListaProfissionaisComponent,
    ListaVagasComponent,
    SubSectorPipe,
    DrawerModule,
    MaisDetalheEmpresaComponent,
    SearchBarComponent,
    TableComponent,
    DataVoidComponent,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    Checkbox,
    TextareaModule,
    HasAnyRoleDirective,
    PdrhComponent,
    Avatar,
    AvatarGroup,
    TooltipModule,
  ],

  providers: [
    ApiService,
    PaisService,
    ProvinciaService,
    DialogService,
    MessageService,
    ConfirmationService,
    EmpresaSectorService,
    ProfissionalService,
    PlanoRecrutamentoService,
    ProfissionaisEnumService,
    PlanoRecrutamentoVagaService,
    CompetenciaService,
  ],
  templateUrl: './detalhe-empresa.component.html',
  styleUrl: './detalhe-empresa.component.scss',
  standalone: true,
})
export class DetalheEmpresaComponent implements OnInit, OnDestroy {
  route = inject(ActivatedRoute);
  router = inject(Router);
  private dialogService = inject(DialogService);
  private messageService = inject(MessageService);
  private empresaService = inject(EmpresaSectorService);
  private confirmationService = inject(ConfirmationService);
  private planoRecrutamentoService = inject(PlanoRecrutamentoService);
  private planoRecrutamentoVagaService = inject(PlanoRecrutamentoVagaService);
  private profissionaisEnumService = inject(ProfissionaisEnumService);
  private profissionalService = inject(ProfissionalService);
  private competenciaService = inject(CompetenciaService);
  @Output() onCloseModal = new EventEmitter<boolean>();
  // Estados da empresa
  readonly ESTADO_ATIVO = 1;
  readonly ESTADO_INATIVO = 2;
  readonly PLANO_PENDENTE = 1;
  readonly PLANO_CONFIRMADO = 2;
  readonly PLANO_REJEITADO = 3;
  empresas: any[] = [];
  listaCompetencias: any[] = [];
  formAddVaga!: FormGroup;
  form!: FormGroup;
  empresaId!: string;
  file: any;
  profissionaisCount: number = 0;
  activeTab: number = 0;
  showFilter: boolean = false;
  tipoContratoOptions: any[] = [];
  nivelHabilitacaoOptions: any[] = [];
  currentYear: number = new Date().getFullYear();
  exercicioOptions: { label: string; value: number }[] = [];
  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'Exercicio',
      placeholder: 'Exercício PDRH',
      options: this.exercicioOptions,
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'TipoContrato',
      placeholder: 'Tipo de Contrato',
      options: this.tipoContratoOptions,
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'NivelHabilitacao',
      placeholder: 'Nível de Habilitação',
      options: this.nivelHabilitacaoOptions,
      optionLabel: 'label',
      optionValue: 'value',
    },
  ];

  columns: TableColumn[] = [
    {
      field: 'planoRecrutamentoEstado',
      header: 'Estado',
      type: 'tag',
      formatter: (value, rowData) =>
        value || this.getPlanoEstadoLabel(rowData.planoRecrutamentoEstadoEnum),
      tagSeverityFunction: (rowData) =>
        this.getPlanoEstadoSeverity(rowData.planoRecrutamentoEstadoEnum),
    },
    {
      field: 'numVagas',
      header: 'N.º de Vagas',
      type: 'badge',
      severityField: 'vagasDisponivel',
      badgeSeverityFunction: () => 'info',
    },
    { field: 'vagasDisponivel', header: 'Vagas Disponíveis' },
    { field: 'especialidadeFuncao', header: 'Especialidade' },
    { field: 'profissaoCatalogo', header: 'Profissão de Referência' },
    { field: 'nivelHabilitacao', header: 'Habilitações Académicas' },
    { field: 'experiencia', header: 'Experiência Profissional' },
    { field: 'regimeTrabalho', header: 'Regime de Trabalho' },
    {
      field: 'motivoPlanoRecrutamentoEstado',
      header: 'Motivo',
      formatter: (value) => value || '—',
    },
  ];

  actions = (plano: any): MenuItem[] => this.getPlanoActions(plano);

  @ViewChild(ListaProfissionaisComponent)
  private listaProfissionaisCmp!: ListaProfissionaisComponent;

  @ViewChild(ListaVagasComponent)
  private listaVagasCmp!: ListaVagasComponent;

  @ViewChild(ListaRepresentantesComponent)
  private listaRepresentantesCmp!: ListaRepresentantesComponent;

  isLoading: boolean = false;
  perfilEmpresa: any;
  ref: DynamicDialogRef | undefined;

  maisDetalheEmpresa: any | undefined | null;
  showDetalhe: boolean = false;
  pagination: Pagination<any> = new Pagination<any>();

  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL

  tipoEmpresas: any[] = [
    {
      id: 1,
      designacao: 'Empresa do sector',
    },
    {
      id: 2,
      designacao: 'Manpower',
    },
  ];
  getInitials = getInitials;
  empresaImageError = false;
  companyProfissionais: Array<{
    id: number;
    nome: string;
    photoUrl?: string | null;
    imageError?: boolean;
  }> = [];

  constructor(private fb: FormBuilder) {
    for (let i = 0; i < 5; i++) {
      const year = this.currentYear - i;
      this.exercicioOptions.push({ label: year.toString(), value: year });
    }
    this.filters[0].options = this.exercicioOptions;
  }
  items: MenuItem[] | undefined;

  selectedPlano: any;

  showModalAddvaga = false;
  isSavingVaga = false;
  showModalRejeitarNecessidade = false;
  isUpdatingEstadoPlano = false;
  planoParaRejeitar: any = null;
  motivoRejeicao = '';
  readonly minDataEncerramento = this.createStartOfToday();

  ngOnInit(): void {
    this.empresaId = this.route.snapshot.paramMap.get('id')!;
    this.loadEmpresaDetails(this.empresaId);
    this.loadProfissionaisEnums();
    this.getCompetencias();
    this.items = [
      {
        label: 'Options',
        items: [
          {
            label: 'Editar',
            icon: 'pi pi-pencil',
          },
          {
            label: 'Eiminar',
            icon: 'pi pi-trash',
          },
        ],
      },
    ];

    this.formAddVaga = this.fb.group({
      empresa: [{ value: '', disabled: true }],
      profissaoCatalogo: [{ value: '', disabled: true }],
      especialidadeFuncao: [{ value: '', disabled: true }],
      tipoContrato: [{ value: '', disabled: true }],
      nivelHabilitacao: [{ value: '', disabled: true }],
      experiencia: [{ value: '', disabled: true }],
      regimeTrabalho: [{ value: '', disabled: true }],
      numeroVaga: [null, [Validators.required]],
      localizacao: [null, Validators.required],
      dataEncerramento: [null, Validators.required],
      descricao: [''],
      descricaoVaga: [''],
      competenciaID: [null],
      novaCompetencia: [''],
      usarNova: [false],
      vagaCompetencias: this.fb.array([]),
    });

    this.form = this.fb.group({
      Exercicio: [null],
      TipoContrato: [null],
      NivelHabilitacao: [null],
    });
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }

  /**
   * Alterna o estado da empresa (Activa/Inactiva)
   */
  toggleEstadoEmpresa(): void {
    if (!this.perfilEmpresa?.id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'ID da empresa não encontrado.',
        life: 3000,
      });
      return;
    }

    const isInativo = this.isEmpresaInativa();
    const acao = isInativo ? 'activar' : 'desactivar';
    const acaoPassado = isInativo ? 'activada' : 'desactivada';
    const acaoCapitalizado = isInativo ? 'Activar' : 'Desactivar';

    // Confirmação antes de fazer a ação
    this.confirmationService.confirm({
      header: `${acaoCapitalizado} Empresa?`,
      message: `Tem a certeza que deseja ${acao} a empresa ${this.perfilEmpresa?.nome ?? 'selecionada'}?`,
      rejectButtonProps: {
        label: 'Cancelar',
        icon: 'pi pi-times',
        outlined: true,
        size: 'small',
      },
      acceptButtonProps: {
        label: 'Sim',
        icon: 'pi pi-check',
        size: 'small',
      },
      accept: () => {
        this.isLoading = true;

        // Chamar o endpoint apropriado
        const request$ = isInativo
          ? this.empresaService.ativarEmpresa(this.perfilEmpresa.id)
          : this.empresaService.desativarEmpresa(this.perfilEmpresa.id);

        request$.subscribe({
          next: (response: any) => {
            console.log('Resposta da API:', response);

            // Actualizar o estado local
            this.perfilEmpresa.estadoContrato = isInativo
              ? this.ESTADO_ATIVO
              : this.ESTADO_INATIVO;

            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: `Empresa ${acaoPassado} com sucesso!`,
              life: 3000,
            });

            this.isLoading = false;

            // Recarregar dados após 2 segundos
            setTimeout(() => {
              this.loadEmpresaDetails(this.empresaId);
            }, 2000);
          },
          error: (error: any) => {
            console.error(`Erro ao ${acao} empresa:`, error);

            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: `Erro ao ${acao} empresa. Tente novamente.`,
              life: 3000,
            });

            this.isLoading = false;
          },
        });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: `Operação de ${acao} cancelada.`,
          life: 3000,
        });
      },
    });
  }

  loadFotoById(empresaId: number) {
    this.empresaService.getPhotoEmpresaIdGet(empresaId).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreview = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error('Erro ao carregar imagem da empresa:', err);
        this.imagePreview = null;
      },
    });
  }

  loadEmpresaDetails(empresaId: string) {
    this.empresaImageError = false;
    this.empresaService.show(empresaId).subscribe({
      next: (result: any) => {
        this.perfilEmpresa = result;
        this.loadFotoById(this.perfilEmpresa.id);
        this.loadPlanoRecrutamento();
        this.loadProfissionaisEmpresa(this.perfilEmpresa.id);
      },
    });
  }

  loadProfissionaisEmpresa(empresaId: number | string) {
    this.profissionalService
      .list({ EmpresaID: empresaId, pageNumber: 1, pageSize: 4 })
      .subscribe({
        next: (result: any) => {
          const list = result?.data || [];
          this.companyProfissionais = list.slice(0, 4).map((prof: any) => ({
            id: prof.id,
            nome: prof.nome,
            photoUrl: null,
            imageError: false,
          }));

          this.companyProfissionais.forEach((prof) => {
            this.profissionalService.getPhoto(String(prof.id)).subscribe({
              next: (response: any) => {
                if (response && response.type?.startsWith('image/')) {
                  const reader = new FileReader();
                  reader.onload = () => {
                    prof.photoUrl = reader.result as string;
                  };
                  reader.readAsDataURL(response);
                }
              },
              error: () => {
                prof.photoUrl = null;
              },
            });
          });
        },
        error: (err: any) => {
          console.warn('Erro ao carregar profissionais da empresa para o círculo:', err);
        },
      });
  }

  loadProfissionaisEnums() {
    forkJoin({
      tipoContrato: this.profissionaisEnumService.getAllTipoContrato(),
      nivelHabilitacao: this.profissionaisEnumService.getAllNivelHabilitacao(),
    }).subscribe((response: any) => {
      if (response.tipoContrato?.data) {
        this.tipoContratoOptions = Object.entries(
          response.tipoContrato.data,
        ).map(([key, value]) => ({
          value: Number(key),
          label: value,
        })) as any;
      }

      this.filters[1].options = this.tipoContratoOptions;

      if (response.nivelHabilitacao?.data) {
        this.nivelHabilitacaoOptions = Object.entries(
          response.nivelHabilitacao.data,
        ).map(([key, value]) => ({
          value: Number(key),
          label: value,
        })) as any;
      }
      this.filters[2].options = this.nivelHabilitacaoOptions;
    });
  }

  getCompetencias() {
    this.competenciaService
      .list({
        pageNumber: 1,
        pageSize: 100,
      })
      .subscribe((result) => {
        if (result.retorno?.codigo === 200 && result.data) {
          this.listaCompetencias = result.data;
        }
      });
  }

  private createStartOfToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  handleFormValueChange(event: any) {
    const queryParams = Object.fromEntries(
      Object.entries(event).filter(
        ([key, value]) => value !== null && value !== '',
      ),
    );
    this.loadPlanoRecrutamento(queryParams);
    this.showFilter = false;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadPlanoRecrutamento();
  }

  loadPlanoRecrutamento(params?: any) {
    const queryParams = {
      ...params,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
      EmpresaID: this.perfilEmpresa?.id,
    };

    this.planoRecrutamentoService.list(queryParams).subscribe({
      next: (result: any) => {
        this.pagination = new Pagination<any>().deserialize(result);
      },
    });
  }

  onPdrhImported(): void {
    this.pagination.pageNumber = 1;
    this.loadPlanoRecrutamento();
  }

  showDialog() {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    const empresaId = this.route.snapshot.paramMap.get('id')!;
    if (id) {
      const ref = this.dialogService.open(CadastrarEmpresaComponent, {
        width: '45%',
        modal: true,
        data: {
          perfilEmpresa: this.perfilEmpresa,
          tipoEmpresas: this.tipoEmpresas,
          isEditMode: true,
        },
      });
      ref.onClose.subscribe((data: any) => {
        if (data instanceof FormData) {
          this.isLoading = true; // Iniciar carregamento
          this.empresaService.update(data, empresaId).subscribe(
            (result) => {
              this.loadEmpresaDetails(empresaId);
              this.isLoading = false; // Parar carregamento
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Empresa actualizada com sucesso.',
                life: 3000,
              });
            },
            (error: any) => {
              console.error('Erro ao actualizar Empresa:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao actualizar Empresa.',
                life: 3000,
              });
              this.isLoading = false; // Parar carregamento
            },
          );
        }
      });
    }
  }

  deletarEmpresa(id: string): void {
    if (id) {
      this.confirmationService.confirm({
        header: 'Desativar Empresa?',
        message: `A empresa ${
          this.perfilEmpresa?.nome ?? 'selecionada'
        } será desativada. Deseja continuar?`,
        rejectButtonProps: {
          label: 'Cancelar',
          icon: 'pi pi-times',
          outlined: true,
          size: 'small',
        },
        acceptButtonProps: {
          label: 'Sim',
          icon: 'pi pi-check',
          size: 'small',
        },
        accept: () => {
          this.isLoading = true; // Iniciar carregamento
          this.empresaService.delete(id).subscribe(
            () => {
              this.empresas = this.empresas.filter(
                (empresa) => empresa.id !== id,
              );
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Empresa desativada com sucesso!',
                life: 3000,
              });
              this.isLoading = false; // Parar carregamento
              // Wait 2 seconds before redirecting
              setTimeout(() => {
                this.router.navigate(['/bolsa-profissionais/empresas']);
              }, 2000);
            },
            (error: any) => {
              console.error('Erro ao eliminar empresa:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao eliminar empresa.',
                life: 3000,
              });
              this.isLoading = false; // Parar carregamento
            },
          );
        },
        reject: () => {
          this.messageService.add({
            severity: 'info',
            summary: 'cancelada',
            detail: 'Empresa não desativada',
            life: 3000,
          });
        },
      });
    }
  }

  actionClick(empresa: any) {
    this.maisDetalheEmpresa = empresa;
    this.showDetalhe = true;
  }

  receberTotal(total: number) {
    this.profissionaisCount = total;
    if (!this.companyProfissionais.length && this.perfilEmpresa?.id) {
      this.loadProfissionaisEmpresa(this.perfilEmpresa.id);
    }
  }

  getPlanoActions(plano: any): MenuItem[] {
    const estado = Number(plano?.planoRecrutamentoEstadoEnum);

    if (estado === this.PLANO_PENDENTE) {
      return [
        {
          label: 'Validar necessidade',
          icon: 'pi pi-check',
          command: () => this.confirmarNecessidade(plano),
        },
        {
          label: 'Rejeitar necessidade',
          icon: 'pi pi-times',
          command: () => this.abrirRejeicaoNecessidade(plano),
        },
      ];
    }

    if (
      estado === this.PLANO_CONFIRMADO &&
      Number(plano?.vagasDisponivel ?? plano?.numVagas ?? 0) > 0
    ) {
      return [
        {
          label: 'Criar Vaga',
          icon: 'pi pi-plus',
          command: () => this.showAddVaga(plano),
        },
      ];
    }

    return [];
  }

  getPlanoEstadoLabel(estado: number | string | null | undefined): string {
    switch (Number(estado)) {
      case this.PLANO_PENDENTE:
        return 'Pendente';
      case this.PLANO_CONFIRMADO:
        return 'Confirmado';
      case this.PLANO_REJEITADO:
        return 'Rejeitado';
      default:
        return 'Não informado';
    }
  }

  getPlanoEstadoSeverity(
    estado: number | string | null | undefined,
  ): 'success' | 'warn' | 'danger' | 'secondary' {
    switch (Number(estado)) {
      case this.PLANO_CONFIRMADO:
        return 'success';
      case this.PLANO_PENDENTE:
        return 'warn';
      case this.PLANO_REJEITADO:
        return 'danger';
      default:
        return 'secondary';
    }
  }

  confirmarNecessidade(plano: any): void {
    if (Number(plano?.planoRecrutamentoEstadoEnum) !== this.PLANO_PENDENTE) {
      return;
    }

    this.confirmationService.confirm({
      header: 'Validar necessidade?',
      message: 'Tem a certeza que deseja validar esta necessidade?',
      rejectButtonProps: {
        label: 'Cancelar',
        icon: 'pi pi-times',
        outlined: true,
        size: 'small',
      },
      acceptButtonProps: {
        label: 'Validar',
        icon: 'pi pi-check',
        size: 'small',
      },
      accept: () =>
        this.atualizarEstadoNecessidade(
          plano.id,
          this.PLANO_CONFIRMADO,
          null,
          'Necessidade validada com sucesso.',
        ),
    });
  }

  abrirRejeicaoNecessidade(plano: any): void {
    if (Number(plano?.planoRecrutamentoEstadoEnum) !== this.PLANO_PENDENTE) {
      return;
    }

    this.planoParaRejeitar = plano;
    this.motivoRejeicao = '';
    this.showModalRejeitarNecessidade = true;
  }

  rejeitarNecessidade(): void {
    const motivo = this.motivoRejeicao.trim();
    if (!motivo) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Motivo obrigatório',
        detail: 'Informe o motivo da rejeição da necessidade.',
        life: 3000,
      });
      return;
    }

    if (
      !this.planoParaRejeitar?.id ||
      Number(this.planoParaRejeitar.planoRecrutamentoEstadoEnum) !==
        this.PLANO_PENDENTE
    ) {
      return;
    }

    this.atualizarEstadoNecessidade(
      this.planoParaRejeitar.id,
      this.PLANO_REJEITADO,
      motivo,
      'Necessidade rejeitada com sucesso.',
      true,
    );
  }

  private atualizarEstadoNecessidade(
    id: number,
    estado: number,
    motivo: string | null,
    successMessage: string,
    fecharModalRejeicao = false,
  ): void {
    if (this.isUpdatingEstadoPlano) return;

    this.isUpdatingEstadoPlano = true;
    this.planoRecrutamentoService.updateEstado(id, estado, motivo).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: successMessage,
          life: 3000,
        });
        this.isUpdatingEstadoPlano = false;
        if (fecharModalRejeicao) {
          this.fecharRejeicaoNecessidade();
        }
        this.loadPlanoRecrutamento();
      },
      error: (err) => {
        console.error('Erro ao actualizar estado da necessidade:', err);
        this.isUpdatingEstadoPlano = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível actualizar o estado da necessidade.',
          life: 3000,
        });
      },
    });
  }

  fecharRejeicaoNecessidade(): void {
    if (this.isUpdatingEstadoPlano) return;
    this.showModalRejeitarNecessidade = false;
    this.planoParaRejeitar = null;
    this.motivoRejeicao = '';
  }

  showAddVaga(data: any) {
    if (Number(data?.planoRecrutamentoEstadoEnum) !== this.PLANO_CONFIRMADO) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Necessidade não validada',
        detail: 'A vaga só pode ser criada após a validação da necessidade.',
        life: 3000,
      });
      return;
    }

    const vagasDisponiveis = Number(data.vagasDisponivel ?? data.numVagas ?? 0);
    if (vagasDisponiveis <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Plano indisponível',
        detail: 'Esta necessidade já não possui vagas disponíveis.',
        life: 3000,
      });
      return;
    }

    this.resetAddVagaForm();
    this.selectedPlano = { ...data, vagasDisponivel: vagasDisponiveis };
    this.formAddVaga.patchValue({
      empresa: data.empresa,
      profissaoCatalogo: data.profissaoCatalogo,
      especialidadeFuncao: data.especialidadeFuncao,
      tipoContrato: data.tipoContrato,
      nivelHabilitacao: data.nivelHabilitacao,
      experiencia: data.experiencia,
      regimeTrabalho: data.regimeTrabalho,
      numeroVaga: vagasDisponiveis,
      localizacao: data.localizacao ?? this.perfilEmpresa?.localizacao ?? '',
      dataEncerramento: data.dataEncerramento
        ? new Date(data.dataEncerramento)
        : null,
      descricao: data.descricao ?? '',
      descricaoVaga: data.descricaoVaga ?? '',
    });

    this.formAddVaga
      .get('numeroVaga')
      ?.setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(vagasDisponiveis),
      ]);
    this.formAddVaga.get('numeroVaga')?.updateValueAndValidity();

    this.showModalAddvaga = true;
  }

  get vagaCompetencias(): FormArray {
    return this.formAddVaga.get('vagaCompetencias') as FormArray;
  }

  adicionarCompetencia() {
    const usarNova = this.formAddVaga.get('usarNova')?.value;

    if (usarNova) {
      const nova = this.formAddVaga.get('novaCompetencia')?.value?.trim();
      if (nova) {
        this.vagaCompetencias.push(
          this.fb.group({
            competenciaID: [null],
            novaCompetencia: [nova],
            usarNova: [true],
          }),
        );
        this.formAddVaga.get('novaCompetencia')?.reset();
      }
    } else {
      const id = this.formAddVaga.get('competenciaID')?.value;
      if (id) {
        this.vagaCompetencias.push(
          this.fb.group({
            competenciaID: [id],
            novaCompetencia: [''],
            usarNova: [false],
          }),
        );
        this.formAddVaga.get('competenciaID')?.reset();
      }
    }
  }

  getNomeCompetencia(id: number): string {
    const found = this.listaCompetencias.find((c) => c.id === id);
    return found ? found.designacao : 'Desconhecida';
  }

  createVagaCompetencia(): FormGroup {
    return this.fb.group({
      competenciaID: [null],
      novaCompetencia: [''],
      usarNova: [false],
    });
  }

  removeVagaCompetencia(index: number) {
    this.vagaCompetencias.removeAt(index);
  }

  resetAddVagaForm(): void {
    if (!this.formAddVaga || this.isSavingVaga) return;
    this.formAddVaga.reset({ usarNova: false });
    this.vagaCompetencias.clear();
    this.selectedPlano = null;
  }

  salvarVaga(): void {
    if (
      Number(this.selectedPlano?.planoRecrutamentoEstadoEnum) !==
      this.PLANO_CONFIRMADO
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Necessidade não validada',
        detail: 'A vaga só pode ser criada após a validação da necessidade.',
        life: 3000,
      });
      this.showModalAddvaga = false;
      return;
    }

    if (this.formAddVaga.invalid) {
      this.formAddVaga.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
        life: 3000,
      });
      return;
    }

    const formValue = this.formAddVaga.getRawValue();
    const vagaCompetencias = this.vagaCompetencias.controls
      .filter((group) => !group.get('usarNova')?.value)
      .map((group) => ({ competenciaID: group.get('competenciaID')?.value }));
    const novasCompetencias = this.vagaCompetencias.controls
      .filter((group) => group.get('usarNova')?.value)
      .map((group) => ({ designacao: group.get('novaCompetencia')?.value }));

    const params = {
      id: 0,
      planoRecrutamentoID: this.selectedPlano.id,
      numeroVaga: formValue.numeroVaga,
      localizacao: formValue.localizacao,
      dataEncerramento: formValue.dataEncerramento,
      descricao: formValue.descricao,
      descricaoVaga: formValue.descricaoVaga,
      vagaCompetencias,
      novasCompetencias,
    };

    this.isSavingVaga = true;
    this.planoRecrutamentoVagaService.add(params).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Vaga criada com sucesso.',
          life: 3000,
        });
        this.isSavingVaga = false;
        this.showModalAddvaga = false;
        this.loadPlanoRecrutamento();
      },
      error: (err) => {
        console.error('Erro ao criar vaga:', err);
        this.isSavingVaga = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível criar a vaga.',
          life: 3000,
        });
      },
    });
  }

  onTabClick(tabIndexOrEvent: number | Event) {
    // se veio um Event, a gente usa o índice atual
    const idx =
      typeof tabIndexOrEvent === 'number' ? tabIndexOrEvent : this.activeTab;
    console.log('Tab clicked:', idx);
    switch (idx) {
      case 0:
        this.listaProfissionaisCmp.getProfissionais();
        break;
      case 1:
        this.listaVagasCmp.getAllVagas();
        break;
      case 2:
        this.loadPlanoRecrutamento();
        break;
      case 3:
        this.listaRepresentantesCmp.getAllRepresentantesEmpresas({
          EmpresaID: this.empresaId,
        });
        break;
    }
  }

  /**
   * Verifica se a empresa está inativa
   */
  isEmpresaInativa(): boolean {
    return this.perfilEmpresa?.estadoContrato === this.ESTADO_INATIVO;
  }

  /**
   * Retorna o texto do botão baseado no estado
   */
  getTextoBotaoToggle(): string {
    return this.isEmpresaInativa() ? 'Activar Empresa' : 'Desactivar Empresa';
  }

  /**
   * Retorna a severidade do botão (com tipo correto)
   */
  getSeveridadeBotaoToggle(): ButtonSeverity {
    return this.isEmpresaInativa() ? 'success' : 'danger';
  }
  /**
   * Retorna o ícone do botão
   */
  getIconeBotaoToggle(): string {
    return this.isEmpresaInativa() ? 'pi pi-check' : 'pi pi-times';
  }

  /**
   * Navega para editar empresa
   */
  editarEmpresa(): void {
    console.log('Editar empresa:', this.perfilEmpresa?.id);
    // this.router.navigate(['/empresas', this.perfilEmpresa?.id, 'editar']);
  }

  /**
   * Ver mais detalhes da empresa
   */
  verMaisSobreEmpresa(): void {
    console.log('Ver mais sobre:', this.perfilEmpresa?.id);
    // this.router.navigate(['/empresas', this.perfilEmpresa?.id, 'detalhes']);
  }
}